<template>
  <div class="information-box hit-cursor" @click="handleClick">
    <div class="box-top">
      <div class="title">
        <el-tag size="mini" type="success" effect="dark"> 工厂方</el-tag>
        <div class="title-text ellipsis">{{ data.title || '--' }}</div>
      </div>
      <div class="content">{{ data.desc || '--' }}</div>
      <div class="time-look">
        <span>{{ data.created_at || '--' }}</span>
        <span> <i class="el-icon-view"></i>&nbsp;{{ data.view_count || '--' }}</span>
      </div>
    </div>
    <div class="box-footrt">
      <div class="tag-box">
        <el-tag
            size="mini"
            v-for="(item, index) in data.special_machining"
            :key="index"
            type="info"
            effect="dark"
        >
          {{ item }}
        </el-tag>
      </div>
      <i class="el-icon-more"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: "information",
  
  props: {
    data: {
      type: Object,
      default: () => {
      },
    }
  },
  mounted() {
    this.data.special_machining = this.data.special_machining.slice(0, 3)
  },
  methods: {
    handleClick() {
      if (!this.mixCheckLogin()) {
        return;
      }
      this.$router.push({
        path: '/project/demand',
        query: {
          id: this.data.id
        }
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.information-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 310px;
  height: 224px;
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid #e7eaf3;
  padding: 15px;
  box-sizing: border-box;

  .title {
    display: flex;
    align-items: center;

    .title-text {
      display: inline-block;
      margin-left: 12px;
      width: 196px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-weight: bold;
      font-size: var(--font-size-default-16);
      color: #525666;
    }
  }

  .box-top {
    padding-bottom: 15px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex: 1;
  }

  .content {
    width: 280px;
    height: 60px;
    font-weight: 400;
    font-size: var(--font-size-default-14);
    color: #7a8199;
    padding: 16px 0 19px;
    display: -webkit-box; /* 使用WebKit的盒子模型 */
    -webkit-line-clamp: 3; /* 限制显示两行 */
    -webkit-box-orient: vertical; /* 设置盒子方向为垂直 */
    overflow: hidden; /* 超出部分隐藏 */
    text-overflow: ellipsis; /* 超出部分显示省略号 */
  }

  .time-look {
    display: flex;
    justify-content: space-between;
    font-weight: 400;
    font-size: var(--font-size-default-14);
    color: #7a8199;
  }

  .box-footrt {
    border-top: 1px solid #E7EAF3;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 12px;
    color: #5F616C;

    .tag-box {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }
  }
}
</style>
